import React from "react";
import { InputNumber } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

// InputNumber uses generics for ValueType
interface TrebbleInputNumberProps<ValueType extends number | string = number | string>
  extends React.ComponentProps<typeof InputNumber<ValueType>> {
  useEditorTheme?: boolean;
}

const TrebbleInputNumber = <ValueType extends number | string = number | string>(
  { useEditorTheme, ...restProps }: TrebbleInputNumberProps<ValueType>
) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <InputNumber<ValueType> {...restProps} />
    </TrebbleConfigProvider>
  );
};

export default TrebbleInputNumber; 